/**
 * Тот же принцип, что и slugifyCategoryName() в api/category_helpers.php:
 * нижний регистр, любая последовательность не-буквенно-цифровых символов → дефис,
 * обрезка дефисов по краям. Держим в одном месте, чтобы слаги совпадали с бэкендом
 * для студий, продюсеров и категорий.
 */
export const slugify = (name) => {
    const cleaned = String(name || '').trim();
    if (!cleaned) return '';
    return cleaned
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, '-')
        .replace(/^-+|-+$/g, '');
};
